import { render, staticRenderFns } from "./CartOverview.vue?vue&type=template&id=54a919cf&scoped=true&"
import script from "./CartOverview.vue?vue&type=script&lang=js&"
export * from "./CartOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a919cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54a919cf')) {
      api.createRecord('54a919cf', component.options)
    } else {
      api.reload('54a919cf', component.options)
    }
    module.hot.accept("./CartOverview.vue?vue&type=template&id=54a919cf&scoped=true&", function () {
      api.rerender('54a919cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/CartOverview.vue"
export default component.exports